import React from "react"
import PropTypes from "prop-types"
import {
  StyledCard,
  ImgContainer,
  Img,
  Content,
  Icon,
  ReferralContainer,
  ReferralCode,
  Url,
  H2,
  UrlWrapper,
  ImgWrapper,
  Actions
} from "./styles"
import { faCheck, faLock, faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CopyToClipboard } from "react-copy-to-clipboard"

const showUrl = (url, locked) => !!url && !locked

const MediaCard = ({
  children,
  image,
  completed,
  referralCode,
  url,
  title,
  locked,
  simpleForm,
  forceMobile,
  alert,
  buttonLabel,
  ...rest
}) => (
  <StyledCard simpleForm={simpleForm} forceMobile={forceMobile} {...rest}>
    <ImgContainer simpleForm={simpleForm} forceMobile={forceMobile}>
      {showUrl(url, locked) ? (
        <UrlWrapper href={url} target="_blank">
          <Img src={image} completed={completed} simpleForm={simpleForm} forceMobile={forceMobile} />
        </UrlWrapper>
      ) : (
        <ImgWrapper completed={completed}>
          <Img src={image} completed={completed} simpleForm={simpleForm} forceMobile={forceMobile} />
        </ImgWrapper>
      )}

      {!!completed && !locked && <Icon icon={faCheck} />}
      {!!locked && !completed && <Icon icon={faLock} />}
    </ImgContainer>
    <Content simpleForm={simpleForm} forceMobile={forceMobile}>
      {!!title && (
        <>
          {showUrl(url, locked) ? (
            <UrlWrapper href={url} target="_blank">
              <H2 simpleForm={simpleForm} forceMobile={forceMobile}>
                {title}
              </H2>
            </UrlWrapper>
          ) : (
            <H2 simpleForm={simpleForm} forceMobile={forceMobile}>
              {title}
            </H2>
          )}
        </>
      )}
      {children}
    </Content>
    {referralCode !== undefined && (
      <Actions forceMobile={forceMobile}>
        {referralCode === false ? (
          <ReferralContainer clickable={false}>
            <ReferralCode>NO CODE REQUIRED</ReferralCode>
          </ReferralContainer>
        ) : (
          !!referralCode && (
            <CopyToClipboard
              text={referralCode}
              onCopy={() => {
                alert.success("Referral code copied to clipboard")
              }}
            >
              <ReferralContainer clickable>
                <ReferralCode>
                  {referralCode} <FontAwesomeIcon icon={faCopy} />
                </ReferralCode>
              </ReferralContainer>
            </CopyToClipboard>
          )
        )}
        {!!url && showUrl(url, locked) && (
          <Url href={url} target="_blank">
            {buttonLabel || "Visit website"}
          </Url>
        )}
      </Actions>
    )}
  </StyledCard>
)

MediaCard.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white"]),
  gridArea: PropTypes.string,
  image: PropTypes.string.isRequired,
  completed: PropTypes.bool,
  locked: PropTypes.bool,
  url: PropTypes.string,
  forceMobile: PropTypes.bool
}

MediaCard.defaultProps = {
  variant: "default",
  gridArea: undefined,
  completed: false,
  locked: false,
  url: undefined,
  forceMobile: false
}

export default MediaCard
